/*
 * @Author: zjw
 * @Date: 2021-05-17 16:06:26
 * @LastEditTime: 2023-04-04 17:44:36
 * @FilePath: \web-app\src\main.js
 * @Environment: Vue + Element
 * @Description:
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// ElementUI
import ElementUI from 'element-ui';
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);


//引入echarts
// import Echarts from "./plugins/echarts.js";
// Vue.use(Echarts);

// 引入echarts 以及地球
// import * as echarts from 'echarts';
// Vue.prototype.echarts = echarts

//引入echarts
import Echarts from "./plugins/echarts.js";
Vue.use(Echarts);

// Markdown富文本插件
import mavonEditor from "mavon-editor";
import "mavon-editor/dist/css/index.css";
Vue.use(mavonEditor);

// Common 公共方法
import common from "./common/common.js";
Vue.prototype.$common = common;

//引入并注册全局组件(Search、Table、Pagination)
import components from "./utils/components";
Vue.use(components);


//注册全局过滤器
import * as filters from "./utils/filters";
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]); //插入过滤器名和对应方法
});

//注册全局的事件总线(典型的发布订阅模式，解耦能力强)
Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false;

import "@/utils/flexible";

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
